<template>
  <div class="reddit-poll panel-settings">
  </div>
</template>

<script>
export default {
};
</script>
